<template>
  <div>
    <table class="table align-items-center table-flush table-hover bidtbl">
        <thead class="thead-light psticky">
        <tr>
            <th 
            scope="col" 
            class="sort text-left"
             >Name</th>
            <th 
            scope="col" 
            class="sort text-left"
            >Email</th>
            <th 
            scope="col" 
            class="sort text-left"
            >Created Date</th>
            <th 
            scope="col" 
            class=" text-left"
            >Phone Number</th>
            <th 
            scope="col" 
            class=" text-left"
            >Action</th>
        </tr>
        </thead>  
        <tbody class="">
        <tr >
            <td class="text-left">1</td>
            <td class="text-left">2</td>
            <td class="text-left">3</td>
            <td class="text-left">4</td>
            <td class="text-left">
                <button type="button" class="btn btn-success btn-sm my-2">ACCEPT</button>
                <button type="button" class="btn btn-danger btn-sm my-2">REJECT</button>
            </td>
        </tr>
        </tbody>
    </table> 
  </div>
</template>
<script>
import authService from "@/authService";
import config from "@/config";
export default {
  data() {
    return {
        bids : []
    };
  },
  methods : {
    getBids(){
         const auth = {
         headers: {'org-token' : authService.getOrgToken() }
         };
         //var cognitoSub = authService.getUser().cognitoSub;
        // &cognitoSub='+cognitoSub
         this.$http
         .get(
            config.baseUrlBidSide + '/bid-alerts/list?status=READ',
               auth
         )
         .then(result => {
            this.bids = result.data;
         })
    },
    setBidAction(){
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
         };
         this.$http
         .put(
            config.baseUrlBidSide + '/bid/update-order-status',
                {
                  "bidId":"10",
                  "bidAlertId":"3",
                  "status":"ACCEPTED"
                },
               auth
         )
         .then(() => {
            
         })
    }
  },
  created(){
    //this.getBids()   
  }
};
</script>
<style>

</style>